import { MENU_ITEMS } from "@consts";
export default {
	name: "TheDesktopNavigation",
	data() {
		return {
			menuData: [],
		};
	},
	computed: {
		submenuIsOpen() {
			return this.menuData.some((entry) => entry.submenuIsOpen === true);
		},
	},
	watch: {
		submenuIsOpen(value) {
			this.$store.commit("navigation/toggleDesktopSubMenu", value);
		},
	},
	created() {
		const reduceCallback = (acc, item) => {
			if (item.mobileOnly === true) {
				return acc;
			}

			const newItem = {
				...item,
				title: item.title || item.label || "",
			};

			if (Array.isArray(item.submenu)) {
				newItem.submenu = item.submenu.map((entry) => ({
					...entry,
					sectionEntries: Array.isArray(entry.sectionEntries)
						? entry.sectionEntries.reduce(reduceCallback, [])
						: entry.sectionEntries,
				}));
			}

			acc.push(newItem);
			return acc;
		};

		this.menuData = MENU_ITEMS.reduce(reduceCallback, []);
	},
};
